export default __webpack_public_path__ + "static/media/Cucumber.ed46f549.jpg";